const Configuration = {
  // baseUrl: "https://lms-backend-30-production.up.railway.app/",
  //baseUrl: "https://lms-test-production.up.railway.app/",
  baseUrl: "https://nee-tie.com/",
  apis: {
    login: "lms/api/auth/login",
    getAllTenants: "lms/api/admin/getAllTenants",
    getAllCourse: "lms/api/user/getAllCourse",
    saveBadge: "lms/api/user/saveBadge",
    getCourseById: "lms/api/user/getCourseById",
    saveCart: "lms/api/user/saveCart",
    savePurchased: "lms/api/user/savePurchasedCourse",
    getPurchasedCourse: "lms/api/user/getPurchasedCourse",
    getCartByUserId: "lms/api/user/getCartByUserId",
    deleteCartByCartId: "lms/api/user/deleteCartById",
    createPaymentOrder: "lms/api/auth/createOrder",
    updateProfileDetails: "lms/api/user/saveAndEditProfile",
    superLogin: "lms/api/admin/adminLogin",
    tenantLogin: "lms/api/tenant/tenantLogin",
    getAllUsers: "/lms/api/auth/getAllUser",
    deleteUser: "/lms/api/auth/deleteUserById",
    getAllTenantsDetails: "/lms/api/admin/viewAllTenants",
    deleteTenant: "/lms/api/admin/deleteTenantById",
    createUser: "/lms/api/auth/register",
    tenantRegister: "/lms/api/tenant/registerTenant",
    getCourseByUserId: "/lms/api/user/getCourseByUserId",
    deleteCourseById: "/lms/api/user/deleteCourseById",
    uploadCourseForm: "/lms/api/user/saveCourse",
    uploadSectionForm: "/lms/api/user/saveSection",
    videoUpload: "/lms/api/user/uploadFile",
    uploadQuiz: "/lms/api/user/uploadQuizCsv",
    uploadChapter: "/lms/api/user/saveHtmlCourse",
    getAllGroupsApi: "/lms/api/user/getAllClassRooms",
    createGroupApi: "/lms/api/user/createClassRoom",
    tenantAllUsersApi: "/lms/api/user/getAllUsers",
    deleteGroupApi: "/lms/api/user/deleteClassRoom",

    //New ApI's
    leardeBoard: "/lms/api/user/getLeaderBoard",
    courseCompleted: "/lms/api/user/courseComplete",
    reportApi: "/lms/api/user/getReport",
    sendOtp: "/lms/api/auth/send-otp",
    verifyOtp: "/lms/api/auth/verify-otp",
    resetPassword: "/lms/api/auth/reset-password",
    updateCourse: "/lms/api/user/normalUpdateCourse",
    removeProfilePicture: "/lms/api/user/deleteProfileImage",
    saveCourseCompletion:
      "/lms/api/user/saveCompletedSubSectionOrChapterContent",
    payment: "/lms/api/payment/checkout",
    paymentStatus: "/lms/api/payment/paymentStatus",
    promocode: "/lms/api/promo/apply",
  },
};

export default Configuration;
